<ng-container *ngIf="translationStatus$ | async">
    <!--  <h1>{{'LOGIN.WELCOME_HEADER' | translate :{client_display_name:displayName} }}</h1>-->
    <!--  <p *ngIf="!linkId" [innerHTML]="'LOGIN.WELCOME_LABEL' | translate"></p>-->
    <!--  <p *ngIf="linkId" [innerHTML]="'LOGIN.WELCOME_LABEL_ACCOUNT_LINK' | translate"></p>-->

    <!--  Custom may be redundant -->
    <h1 role="heading" *ngIf="gloTypeRegister!=='create'" class="custom-login-info">Einloggen</h1>
    <span *ngIf="gloTypeRegister==='create'" class="custom-login-info">Konto erstellen</span>

    <p *ngIf="shopSource==='checkout'" class="globus-shop-source-paragraph">Sie sind bereits Kunde?</p>

    <div class="section" *ngIf="isClassicalLoginEnabled">
        <app-classic-login-provider [errorMessage]="errorMsg"></app-classic-login-provider>
    </div>

    <div class="section" *ngIf="socialLoginProviders.length > 0">
        <div class="Divider">
            <div class="Divider-text">{{'HR_LINE_LABEL' | translate}}</div>
        </div>
        <app-social-login-provider [providers]="socialLoginProviders"></app-social-login-provider>
    </div>

    <div class="section" *ngIf="customProviders.length > 0">
        <div class="Divider">
            <div class="Divider-text">{{'HR_LINE_LABEL' | translate}}</div>
        </div>
        <app-custom-login-provider [providers]="customProviders" [viewType]="'login'" [remember_me] = isRememberMe ></app-custom-login-provider>
    </div>

    <div class="section" *ngIf="samlProviders.length > 0">
        <div class="Divider">
            <div class="Divider-text">{{'HR_LINE_LABEL' | translate}}</div>
        </div>
        <app-saml-login-provider [providers]="samlProviders" [viewType]="'login'"></app-saml-login-provider>
    </div>

    <div class="section" *ngIf="AD_Providers.length > 0">
        <div class="Divider">
            <div class="Divider-text">{{'HR_LINE_LABEL' | translate}}</div>
        </div>
        <app-ad-login-provider [providers]="AD_Providers"></app-ad-login-provider>
    </div>

    <div class="section" *ngIf="isAllowGuestLogin">
        <div class="Divider">
            <div class="Divider-text">{{'HR_LINE_LABEL' | translate}}</div>
        </div>
        <app-guest-login></app-guest-login>
    </div>

</ng-container>
